function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import last from 'lodash/last';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import { useAction } from 'hooks';
import * as actions from '../../../actions';
import { CHANNEL_COMPONENTS } from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const renderDeviceName = (deviceName)=>/*#__PURE__*/ _jsx("li", {
        className: styles.connection__model,
        children: /*#__PURE__*/ _jsx("span", {
            children: deviceName
        })
    }, deviceName);
const Devices = ({ devices })=>{
    const devicesNames = uniq(map(devices, (device)=>device.name)).sort();
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.connection__models,
        children: map(devicesNames, renderDeviceName)
    });
};
const Connection = ({ name, devicesByChannel, onSetComponent, onSetChannel })=>{
    const downloader = useSelector(selectors.downloader);
    const isDriverInstalled = get(downloader, 'driver.isDriverInstalled', false);
    const driverInstallationState = get(downloader, 'driver.installationState');
    let isActive = true;
    let inactiveInfo = null;
    let blueCable = 'ConnectBlueCable';
    if (!isDriverInstalled) {
        blueCable = driverInstallationState === 'Completed' ? 'InstallingBlueCableDrivers' : 'InstallBlueCableDrivers';
    }
    const components = _object_spread_props(_object_spread({}, CHANNEL_COMPONENTS), {
        BlueCable: blueCable
    });
    const devices = get(devicesByChannel, name, []);
    if (!devices.length) {
        isActive = false;
        inactiveInfo = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.chooseConnection.noSupportedDevices));
    } else if (name === 'Bluetooth') {
        isActive = downloader.bleAvailable;
        if (!isActive) {
            const bleAvailabilityReason = last(downloader.bleAvailabilityReason.split(',')).trim();
            const inactiveMessage = get(messages, [
                'btErrors',
                bleAvailabilityReason
            ]);
            if (inactiveMessage) {
                inactiveInfo = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, inactiveMessage));
            }
        }
    }
    let imageFileName = kebabCase(name);
    if (!isActive) {
        imageFileName += '-inactive';
    }
    const onChoose = ()=>{
        onSetChannel(name);
        onSetComponent(components[name]);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                id: `connect${components[name]}`,
                className: cn(styles.connection__btn, {
                    [styles['connection__btn--inactive']]: !isActive
                }),
                disabled: !isActive,
                onClick: onChoose,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.connection__imageContainer,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: `/assets/svg/${imageFileName}.svg`,
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("h3", {
                className: cn('modal__subheader', {
                    'text--muted': !isActive
                }),
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connections[name])),
                    /*#__PURE__*/ _jsx("br", {}),
                    !isActive && /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.notAvailable))
                ]
            }),
            isActive ? /*#__PURE__*/ _jsx(Devices, {
                devices: devices
            }) : /*#__PURE__*/ _jsx("div", {
                className: styles.connection__inactiveInfo,
                children: inactiveInfo
            })
        ]
    });
};
const ChooseConnection = ({ devicesByChannel, onSetComponent, onSetStyleModifier, onSetChannel })=>{
    const checkStatus = useAction(actions.checkStatus);
    const checkBlueCableDriver = useAction(actions.checkBlueCableDriver);
    const clearConnection = useAction(actions.clearConnection);
    useEffect(()=>{
        onSetStyleModifier('xl');
        checkStatus();
        checkBlueCableDriver();
        clearConnection();
        return ()=>{
            onSetStyleModifier(null);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.chooseConnection.header))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(Connection, {
                            name: "BlueCable",
                            devicesByChannel: devicesByChannel,
                            onSetComponent: onSetComponent,
                            onSetChannel: onSetChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(Connection, {
                            name: "MicroUsb",
                            devicesByChannel: devicesByChannel,
                            onSetComponent: onSetComponent,
                            onSetChannel: onSetChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(Connection, {
                            name: "UsbC",
                            devicesByChannel: devicesByChannel,
                            onSetComponent: onSetComponent,
                            onSetChannel: onSetChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(Connection, {
                            name: "BuiltInUsb",
                            devicesByChannel: devicesByChannel,
                            onSetComponent: onSetComponent,
                            onSetChannel: onSetChannel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(Connection, {
                            name: "Bluetooth",
                            devicesByChannel: devicesByChannel,
                            onSetComponent: onSetComponent,
                            onSetChannel: onSetChannel
                        })
                    })
                ]
            })
        ]
    });
};
export default ChooseConnection;
